import { render } from "./App.vue?vue&type=template&id=974ec0ac"
const script = {}

import "./App.vue?vue&type=style&index=0&id=974ec0ac&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__